module.exports = __webpack_public_path__ + "img/car1.ddf1a79d.jpg";